import dynamicRouters from '../router/dynamicRouters';
import _ from 'lodash';

// 根据权限生成动态路由
const generateRouters = menus => {
  return new Promise((resolve, reject) => {
    if (menus && menus.length) {
      let newRouters = [];
      let children = [],
        childrenMonitor = [];

      // 根据权限生成一级菜单
      menus.map(menu => {
        if (menu.name === 'monitorMaintenance') {
          for (let v of menu.views.pc) {
            if (v.name === 'staticReport') {
              for (let vv of v.auth) {
                const match = dynamicRouters[1].children.find(item => item.meta.title === vv.name);
                if (match) {
                  childrenMonitor.push(match);
                }
              }
            } else {
              const match = dynamicRouters[1].children.find(item => item.meta.title === v.title);
              if (match) {
                childrenMonitor.push(match);
              }
            }
          }
        } else {
          dynamicRouters[0].children.map(dymenu => {
            let dmenu = _.cloneDeep(dymenu);
            if (menu.name === dmenu.name) {
              if (dmenu.children && dmenu.children.length) {
                // 存在二级菜单，根据权限生成二级菜单
                if (menu.views.pc && menu.views.pc.length) {
                  let submenu = [];
                  menu.views.pc.map(view => {
                    dmenu.children.map(dview => {
                      // 处理一级菜单下的子页面
                      if (view.haveMenuSubpage) {
                        let subpage = [];

                        view.auth.map(auth => {
                          if (auth.haveSubpage) {
                            auth.pages.map(page => {
                              if (page === dview.name) {
                                subpage.push(dview);
                              }
                            });
                          }
                        });

                        submenu = subpage;
                      } else {
                        if (dview.name === view.name) {
                          // 处理二级菜单下的子页面
                          if (dview.children && dview.children.length) {
                            let subpage = [];

                            view.auth.map(auth => {
                              if (auth.haveSubpage) {
                                auth.pages.map(page => {
                                  dview.children.map(dpage => {
                                    if (page === dpage.name) {
                                      subpage.push(dpage);
                                    }
                                  });
                                });
                              }
                            });

                            dview.children = subpage;
                            submenu.push(dview);
                          } else {
                            submenu.push(dview);
                          }
                        }
                      }
                    });
                  });

                  dmenu.children = submenu;
                  dmenu.redirect && (dmenu.redirect = `${dmenu.path}/${dmenu.children[0].path}`);
                  children.push(dmenu);
                }
              } else {
                children.push(dmenu);
              }
            }
          });
        }
      });

      if (children.length) {
        newRouters.push({
          path: '/',
          component: () => import('@/views/layout/index.vue'),
          redirect: children[0].path,
          hidden: true,
          children
        });
      } else {
        newRouters.push({
          path: '/',
          component: () => import('@/views/layout/index.vue'),
          redirect: '/monitorMaintenance',
          hidden: true,
          children: []
        });
      }

      if (childrenMonitor.length) {
        const match = childrenMonitor.find(item => item.path === 'deviceMonitor');
        newRouters.push({
          path: '/monitorMaintenance',
          component: () => import('@/views/monitorMaintenance/index.vue'),
          redirect: `/monitorMaintenance/${match ? 'deviceMonitor' : childrenMonitor[0].path}`,
          hidden: true,
          children: childrenMonitor
        });
      }

      resolve(newRouters);
    } else {
      resolve([]);
    }
  });
};

export default generateRouters;
